module.exports = __webpack_public_path__ + "static/media/IMG-4.e858981a.jpg";